import { h } from 'preact';
import { useState } from 'preact/hooks';
import styles from './TextCheckboxList.module.scss';
const SHOW_LIMIT = 8;
const Checkmark = () => (h("svg", { width: "10", height: "8", viewBox: "0 0 10 8", fill: "none" },
    h("path", { d: "M1 4L3.5 6.5L9 1", stroke: "white", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" })));
export function TextCheckboxList({ options, onChange, layout }) {
    const [showAll, setShowAll] = useState(false);
    if (layout === 'filterTop')
        return null;
    const visible = showAll ? options : options.slice(0, SHOW_LIMIT);
    const hasMore = options.length > SHOW_LIMIT;
    return (h("div", { class: styles.list },
        visible.map(option => (h("label", { key: option.id, class: styles.item },
            h("input", { type: "checkbox", class: styles.hiddenInput, checked: option.selected, onChange: () => onChange(option.id) }),
            h("span", { class: `${styles.checkbox} ${option.selected ? styles.checked : ''}` }, option.selected && h(Checkmark, null)),
            h("span", { class: styles.label }, option.label),
            h("span", { class: styles.count },
                "(",
                option.count,
                ")")))),
        hasMore && (h("button", { class: styles.showMore, type: "button", onClick: () => setShowAll(!showAll) }, showAll ? 'Show less' : 'Show more'))));
}
